import { render, staticRenderFns } from "./Famille.vue?vue&type=template&id=248fb761&scoped=true"
import script from "./Famille.vue?vue&type=script&lang=js"
export * from "./Famille.vue?vue&type=script&lang=js"
import style0 from "./Famille.vue?vue&type=style&index=0&id=248fb761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fb761",
  null
  
)

export default component.exports